import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  "data-component": "ConsolePage"
};
const _hoisted_2 = {
  class: "content-main"
};
const _hoisted_3 = {
  class: "content-logs"
};
const _hoisted_4 = {
  class: "content-block events"
};
const _hoisted_5 = {
  class: "visualization"
};
const _hoisted_6 = {
  class: "visualization-entry client"
};
const _hoisted_7 = {
  class: "visualization-entry server"
};
const _hoisted_8 = {
  class: "event-timestamp"
};
const _hoisted_9 = {
  class: "event-details"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "event-type"
};
const _hoisted_12 = {
  key: 0,
  class: "event-payload"
};
const _hoisted_13 = {
  class: "content-block conversation"
};
const _hoisted_14 = {
  class: "content-block-body",
  "data-conversation-content": ""
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "speaker-content"
};
const _hoisted_17 = {
  key: 0
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 2
};
const _hoisted_20 = {
  key: 3
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "content-actions",
  style: {
    "position": "absolute",
    "top": "0",
    "left": "0"
  }
};
import { ref, reactive, onMounted, onUnmounted, watch } from 'vue';
import { RealtimeClient } from '@openai/realtime-api-beta';
import { WavRecorder, WavStreamPlayer } from '@/lib/wavtools/index.js';
import { instructions } from '@/utils/conversation_config.js';
import { WavRenderer } from '@/utils/wav_renderer';

// Constants

export default {
  __name: 'RealtimeTest',
  setup(__props) {
    const LOCAL_RELAY_SERVER_URL = process.env.REACT_APP_LOCAL_RELAY_SERVER_URL || '';

    // Reactive state
    const apiKey = ref(LOCAL_RELAY_SERVER_URL ? '' : localStorage.getItem('tmp::voice_api_key') || prompt('OpenAI API Key') || '');
    const wavRecorder = ref(new WavRecorder({
      sampleRate: 24000
    }));
    const wavStreamPlayer = ref(new WavStreamPlayer({
      sampleRate: 24000
    }));
    const client = ref(new RealtimeClient({
      url: "ws://localhost:5678/api/realtime",
      apiKey: "sk-Gc5cEzDzGQLIqxWA9d62089350F3454bB359C4A3Fa21B3E4",
      dangerouslyAllowAPIKeyInBrowser: true
    }));
    const clientCanvasRef = ref(null);
    const serverCanvasRef = ref(null);
    const eventsScrollRef = ref(null);
    const startTime = ref(new Date().toISOString());
    const items = ref([]);
    const realtimeEvents = ref([]);
    const expandedEvents = reactive({});
    const isConnected = ref(false);
    const canPushToTalk = ref(true);
    const isRecording = ref(false);
    const memoryKv = ref({});
    const coords = ref({
      lat: 37.775593,
      lng: -122.418137
    });
    const marker = ref(null);

    // Methods
    const formatTime = timestamp => {
      const t0 = new Date(startTime.value).valueOf();
      const t1 = new Date(timestamp).valueOf();
      const delta = t1 - t0;
      const hs = Math.floor(delta / 10) % 100;
      const s = Math.floor(delta / 1000) % 60;
      const m = Math.floor(delta / 60_000) % 60;
      const pad = n => {
        let s = n + '';
        while (s.length < 2) {
          s = '0' + s;
        }
        return s;
      };
      return `${pad(m)}:${pad(s)}.${pad(hs)}`;
    };
    const connectConversation = async () => {
      alert(123);
      startTime.value = new Date().toISOString();
      isConnected.value = true;
      realtimeEvents.value = [];
      items.value = client.value.conversation.getItems();
      await wavRecorder.value.begin();
      await wavStreamPlayer.value.connect();
      await client.value.connect();
      client.value.sendUserMessageContent([{
        type: 'input_text',
        text: '你好，我是老阳!'
      }]);
      if (client.value.getTurnDetectionType() === 'server_vad') {
        await wavRecorder.value.record(data => client.value.appendInputAudio(data.mono));
      }
    };
    const disconnectConversation = async () => {
      isConnected.value = false;
      realtimeEvents.value = [];
      items.value = [];
      memoryKv.value = {};
      coords.value = {
        lat: 37.775593,
        lng: -122.418137
      };
      marker.value = null;
      client.value.disconnect();
      await wavRecorder.value.end();
      await wavStreamPlayer.value.interrupt();
    };
    const deleteConversationItem = async id => {
      client.value.deleteItem(id);
    };
    const startRecording = async () => {
      isRecording.value = true;
      const trackSampleOffset = await wavStreamPlayer.value.interrupt();
      if (trackSampleOffset?.trackId) {
        const {
          trackId,
          offset
        } = trackSampleOffset;
        await client.value.cancelResponse(trackId, offset);
      }
      await wavRecorder.value.record(data => client.value.appendInputAudio(data.mono));
    };
    const stopRecording = async () => {
      isRecording.value = false;
      await wavRecorder.value.pause();
      client.value.createResponse();
    };
    const changeTurnEndType = async value => {
      if (value === 'none' && wavRecorder.value.getStatus() === 'recording') {
        await wavRecorder.value.pause();
      }
      client.value.updateSession({
        turn_detection: value === 'none' ? null : {
          type: 'server_vad'
        }
      });
      if (value === 'server_vad' && client.value.isConnected()) {
        await wavRecorder.value.record(data => client.value.appendInputAudio(data.mono));
      }
      canPushToTalk.value = value === 'none';
    };
    const toggleEventDetails = eventId => {
      if (expandedEvents[eventId]) {
        delete expandedEvents[eventId];
      } else {
        expandedEvents[eventId] = true;
      }
    };

    // Lifecycle hooks and watchers
    onMounted(() => {
      if (apiKey.value !== '') {
        localStorage.setItem('tmp::voice_api_key', apiKey.value);
      }

      // Set up render loops for the visualization canvas
      let isLoaded = true;
      const render = () => {
        if (isLoaded) {
          if (clientCanvasRef.value) {
            const canvas = clientCanvasRef.value;
            if (!canvas.width || !canvas.height) {
              canvas.width = canvas.offsetWidth;
              canvas.height = canvas.offsetHeight;
            }
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              const result = wavRecorder.value.recording ? wavRecorder.value.getFrequencies('voice') : {
                values: new Float32Array([0])
              };
              WavRenderer.drawBars(canvas, ctx, result.values, '#0099ff', 10, 0, 8);
            }
          }
          if (serverCanvasRef.value) {
            const canvas = serverCanvasRef.value;
            if (!canvas.width || !canvas.height) {
              canvas.width = canvas.offsetWidth;
              canvas.height = canvas.offsetHeight;
            }
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              const result = wavStreamPlayer.value.analyser ? wavStreamPlayer.value.getFrequencies('voice') : {
                values: new Float32Array([0])
              };
              WavRenderer.drawBars(canvas, ctx, result.values, '#009900', 10, 0, 8);
            }
          }
          requestAnimationFrame(render);
        }
      };
      render();

      // Set up client event listeners
      client.value.on('realtime.event', realtimeEvent => {
        realtimeEvents.value = realtimeEvents.value.slice();
        const lastEvent = realtimeEvents.value[realtimeEvents.value.length - 1];
        if (lastEvent?.event.type === realtimeEvent.event.type) {
          lastEvent.count = (lastEvent.count || 0) + 1;
          realtimeEvents.value.splice(-1, 1, lastEvent);
        } else {
          realtimeEvents.value.push(realtimeEvent);
        }
      });
      client.value.on('error', event => console.error(event));
      client.value.on('conversation.interrupted', async () => {
        const trackSampleOffset = await wavStreamPlayer.value.interrupt();
        if (trackSampleOffset?.trackId) {
          const {
            trackId,
            offset
          } = trackSampleOffset;
          await client.value.cancelResponse(trackId, offset);
        }
      });
      client.value.on('conversation.updated', async ({
        item,
        delta
      }) => {
        items.value = client.value.conversation.getItems();
        if (delta?.audio) {
          wavStreamPlayer.value.add16BitPCM(delta.audio, item.id);
        }
        if (item.status === 'completed' && item.formatted.audio?.length) {
          const wavFile = await WavRecorder.decode(item.formatted.audio, 24000, 24000);
          item.formatted.file = wavFile;
        }
      });

      // Set up client instructions and tools
      client.value.updateSession({
        instructions: instructions
      });
      client.value.updateSession({
        input_audio_transcription: {
          model: 'whisper-1'
        }
      });
      client.value.addTool({
        name: 'set_memory',
        description: 'Saves important data about the user into memory.',
        parameters: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              description: 'The key of the memory value. Always use lowercase and underscores, no other characters.'
            },
            value: {
              type: 'string',
              description: 'Value can be anything represented as a string'
            }
          },
          required: ['key', 'value']
        }
      }, async ({
        key,
        value
      }) => {
        memoryKv.value = {
          ...memoryKv.value,
          [key]: value
        };
        return {
          ok: true
        };
      });
      client.value.addTool({
        name: 'get_weather',
        description: 'Retrieves the weather for a given lat, lng coordinate pair. Specify a label for the location.',
        parameters: {
          type: 'object',
          properties: {
            lat: {
              type: 'number',
              description: 'Latitude'
            },
            lng: {
              type: 'number',
              description: 'Longitude'
            },
            location: {
              type: 'string',
              description: 'Name of the location'
            }
          },
          required: ['lat', 'lng', 'location']
        }
      }, async ({
        lat,
        lng,
        location
      }) => {
        marker.value = {
          lat,
          lng,
          location
        };
        coords.value = {
          lat,
          lng,
          location
        };
        const result = await fetch(`https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}&current=temperature_2m,wind_speed_10m`);
        const json = await result.json();
        const temperature = {
          value: json.current.temperature_2m,
          units: json.current_units.temperature_2m
        };
        const wind_speed = {
          value: json.current.wind_speed_10m,
          units: json.current_units.wind_speed_10m
        };
        marker.value = {
          lat,
          lng,
          location,
          temperature,
          wind_speed
        };
        return json;
      });
      items.value = client.value.conversation.getItems();
    });
    onUnmounted(() => {
      client.value.reset();
    });

    // Watchers
    watch(realtimeEvents, () => {
      if (eventsScrollRef.value) {
        const eventsEl = eventsScrollRef.value;
        eventsEl.scrollTop = eventsEl.scrollHeight;
      }
    });
    watch(items, () => {
      const conversationEls = document.querySelectorAll('[data-conversation-content]');
      conversationEls.forEach(el => {
        el.scrollTop = el.scrollHeight;
      });
    });
    return (_ctx, _cache) => {
      const _component_X = _resolveComponent("X");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "content-top"
      }, [_createElementVNode("div", {
        class: "content-title"
      }, [_createElementVNode("img", {
        src: "/openai-logomark.svg",
        alt: "OpenAI Logo"
      }), _createElementVNode("span", null, "realtime console")])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("canvas", {
        ref_key: "clientCanvasRef",
        ref: clientCanvasRef
      }, null, 512)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("canvas", {
        ref_key: "serverCanvasRef",
        ref: serverCanvasRef
      }, null, 512)])]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "content-block-title"
      }, "events", -1)), _createElementVNode("div", {
        class: "content-block-body",
        ref_key: "eventsScrollRef",
        ref: eventsScrollRef
      }, [!realtimeEvents.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(" awaiting connection... ")], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(realtimeEvents.value, (realtimeEvent, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: realtimeEvent.event.event_id,
          class: "event"
        }, [_createElementVNode("div", _hoisted_8, _toDisplayString(formatTime(realtimeEvent.time)), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: "event-summary",
          onClick: $event => toggleEventDetails(realtimeEvent.event.event_id)
        }, [_createElementVNode("div", {
          class: _normalizeClass(['event-source', realtimeEvent.event.type === 'error' ? 'error' : realtimeEvent.source])
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(realtimeEvent.source === 'client' ? _ctx.ArrowUp : _ctx.ArrowDown))), _createElementVNode("span", null, _toDisplayString(realtimeEvent.event.type === 'error' ? 'error!' : realtimeEvent.source), 1)], 2), _createElementVNode("div", _hoisted_11, _toDisplayString(realtimeEvent.event.type) + " " + _toDisplayString(realtimeEvent.count ? `(${realtimeEvent.count})` : ''), 1)], 8, _hoisted_10), expandedEvents[realtimeEvent.event.event_id] ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(JSON.stringify(realtimeEvent.event, null, 2)), 1)) : _createCommentVNode("", true)])]);
      }), 128))], 512)]), _createElementVNode("div", _hoisted_13, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "content-block-title"
      }, "conversation", -1)), _createElementVNode("div", _hoisted_14, [!items.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(" awaiting connection... ")], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(items.value, (conversationItem, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: conversationItem.id,
          class: "conversation-item"
        }, [_createElementVNode("div", {
          class: _normalizeClass(['speaker', conversationItem.role || ''])
        }, [_createElementVNode("div", null, _toDisplayString((conversationItem.role || conversationItem.type).replaceAll('_', ' ')), 1), _createElementVNode("div", {
          class: "close",
          onClick: $event => deleteConversationItem(conversationItem.id)
        }, [_createVNode(_component_X)], 8, _hoisted_15)], 2), _createElementVNode("div", _hoisted_16, [conversationItem.type === 'function_call_output' ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(conversationItem.formatted.output), 1)) : _createCommentVNode("", true), conversationItem.formatted.tool ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(conversationItem.formatted.tool.name) + "( " + _toDisplayString(conversationItem.formatted.tool.arguments) + ") ", 1)) : _createCommentVNode("", true), !conversationItem.formatted.tool && conversationItem.role === 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(conversationItem.formatted.transcript || (conversationItem.formatted.audio?.length ? '(awaiting transcript)' : conversationItem.formatted.text || '(item sent)')), 1)) : _createCommentVNode("", true), !conversationItem.formatted.tool && conversationItem.role === 'assistant' ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(conversationItem.formatted.transcript || conversationItem.formatted.text || '(truncated)'), 1)) : _createCommentVNode("", true), conversationItem.formatted.file ? (_openBlock(), _createElementBlock("audio", {
          key: 4,
          src: conversationItem.formatted.file.url,
          controls: ""
        }, null, 8, _hoisted_21)) : _createCommentVNode("", true)])]);
      }), 128))])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
        type: isConnected.value ? '' : 'primary',
        onClick: connectConversation
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(isConnected.value ? '断开连接' : '连接对话'), 1)]),
        _: 1
      }, 8, ["type"]), _createVNode(_component_el_button, {
        onMousedown: startRecording,
        onMouseup: stopRecording
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("开始讲话")])),
        _: 1
      })])])])]);
    };
  }
};